import { render, staticRenderFns } from "./DocumentUploaderModal.vue?vue&type=template&id=29be8964&"
import script from "./DocumentUploaderModal.vue?vue&type=script&lang=js&"
export * from "./DocumentUploaderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports